<script setup lang="ts">
import FilledStar from '@shared/components/Icons/FilledStar.vue'
import StarsCover from '@/components/Product/ProductTabs/StarsCover.vue'

type Props = {
    rate: number
}

const { rate } = defineProps<Props>()
</script>

<template>
    <div class="inline-flex gap-1 relative">
        <filled-star
            v-for="i in 5"
            :key="i"
            class="w-5 h-5"
        />

        <stars-cover :cover-width="100 - (rate * 20)" />
    </div>
</template>